import { useEffect, useState } from "react";

const MOBILE_BREAKPOINT = 768;

export function useIsMobile() {
  const [isMobile, setIsMobile] = useState<boolean | undefined>(undefined);

  useEffect(() => {
    const maxWidth = MOBILE_BREAKPOINT - 1;
    const breakpoint = window.matchMedia(`(max-width: ${maxWidth}px)`);

    const handleChange = () => {
      setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);
    };

    breakpoint.addEventListener("change", handleChange);

    setIsMobile(window.innerWidth < MOBILE_BREAKPOINT);

    return () => breakpoint.removeEventListener("change", handleChange);
  }, []);

  return !!isMobile;
}
